import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { Avatar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useBox } from 'shared/hooks/utils';
import { TimedRenderer } from 'console/react-elements/timed-renderer';
import AvatarGroup from '@mui/material/AvatarGroup';
import { iconDefaultAccount } from 'console/left-menu/header/icons/default-icon';
export const AvatarInSettings = memo(function AnimatedAvatar() {
    const theme = useTheme();
    const iconArrayAccount = useMemo(() => iconDefaultAccount(theme), [theme]);
    const _index = useBox(0);
    return (_jsx(TimedRenderer, { active: true, interval: 1e3, children: () => {
            if (_index.current < iconArrayAccount.length - 1) {
                _index.current = _index.current + 1;
            }
            else {
                _index.current = 0;
            }
            return (_jsx(Avatar, { className: "profile", sx: iconArrayAccount[_index.current].sx, children: iconArrayAccount[_index.current].component }, iconArrayAccount[_index.current].title));
        } }));
});
export const NotAnimatedAvatarInSettings = memo(function NotAnimatedAvatar() {
    const theme = useTheme();
    return (_jsx(AvatarGroup, { max: 3, sx: {
            '& .MuiAvatar-root ': {
                border: 'none',
            },
        }, children: iconDefaultAccount(theme).map(({ sx, title, component }) => (_jsx(Avatar, { className: 'profile', sx: sx, children: component }, title))) }));
});
